var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"frame",staticClass:"news-crop-img"},[_c('img',{ref:"img",staticClass:"news-crop-img__el",attrs:{"src":_vm.imageSrc,"alt":_vm.alt,"draggable":"false"},on:{"load":_vm.onLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }